<template>
	<modal
		v-model="dialog"
		:width="width || '520px'"
		:title="title || $t('warning')"
		type="question"
		persistent
		:cancel-text="cancel || $t('cancel')"
		:confirm-text="confirm || $t('quit')"
		:hide-cta="hideCta"
		:show-close-button="showCloseButton"
		:content-class="contentClass"
		@cancel="handleCancel"
		@confirm="handleSubmit"
	>
		<v-card flat class="py-2 px-4 mb-2">
			<span>
				{{ body || $t("unsaved-changes-warning") }}
			</span>
		</v-card>
	</modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/common/Modal";

export default {
	name: "ConfirmationDialog",
	components: { Modal },

	props: {
		contentClass: {
			type: String,
			default: ""
		}
	},

	data: () => ({
		dialog: false,
		resolve: null,
		reject: null,
		title: null,
		body: null,
		confirm: null,
		cancel: null,
		width: null,
		hideCta: false,
		showCloseButton: false
	}),

	computed: {
		...mapGetters("clinic", ["clinicData"]),
		...mapGetters("login", ["profile"])
	},

	methods: {
		open(dialogContent) {
			const { title = "", body = "", confirm = "", cancel = "", width = "", hideCta = false, showCloseButton = false } = dialogContent || {};

			this.title = title;
			this.body = body;
			this.confirm = confirm;
			this.cancel = cancel;
			this.width = width;
			this.hideCta = hideCta;
			this.showCloseButton = showCloseButton;

			return new Promise((resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;

				this.dialog = true;
			});
		},

		handleSubmit() {
			this.dialog = false;
			this.resolve("submit");
		},

		handleCancel() {
			this.dialog = false;
			this.reject("cancel");
		}
	}
};
</script>
